module.exports = __webpack_public_path__ + "static/icosahedron-2-97f37dd5941bf5120bb1aa326d3fd507.png";